export enum SearchFor {
  StopAreas = 'stopAreas',
  Stops = 'stops',
  Terminals = 'terminals',
}
